import React from "react";
import RingBuilderApiEndPoint from "../RingBuilder/RingBuilderApiEndPoint";
const DiamondLinkApiEndPoint = () => {
  return <RingBuilderApiEndPoint type="Diamond" />;
};
export default DiamondLinkApiEndPoint;
